<div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="type == 'warning'">
  {{ message | translate }}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"
    (click)="_resourceService.alert = null">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="type == 'danger'">
  {{ message | translate }}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"
    (click)="_resourceService.alert = null">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="type == 'success'">
  {{ message | translate }}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"
    (click)="_resourceService.alert = null">
    <span aria-hidden="true">&times;</span>
  </button>
</div>